import { MAP_AD_REFRESH, MapAdRefreshActionType } from '../actions/mapAdRefreshActions';

export interface MapAdRefreshState {
    userMapInteraction?: string;
}

const initialState: MapAdRefreshState = {
    userMapInteraction: ''
};

export function mapAdRefresh(state = initialState, action: MapAdRefreshActionType): MapAdRefreshState
{
    switch (action.type)
    {
        case MAP_AD_REFRESH:
        {
            return {
                ...state,
                userMapInteraction: action.payload
            };
        }
        default: 
        {
            return state;
        }
    }
}
